
import { FormFeedback, Input, Label, ListGroup, ListGroupItem } from "reactstrap";
import { Tagente } from "../../Types/UsersType";
import { FaTrash } from 'react-icons/fa';
import DatePicker, { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { ptBR } from "date-fns/locale";
import { useState, useEffect } from "react";
import { Api } from "../../Services/CohortServices";
registerLocale("pt-BR", ptBR);


type Props = {
  selectedAttributes: any[];
  handleInputChange: (id: string, field: string, value: any) => void;
  RemoveDragableItem: (id: string) => void;
  startDate: Date | null;
  endDate: Date | null;
  startDateConsulta: Date | null;
  endDateConsulta: Date | null;
  setDateRange: (dates: [Date | null, Date | null]) => void;
  setDateConsulta: (dates: [Date | null, Date | null]) => void;
};


export const ListAtributesSelectedComponent = (props: Props) => {
  const [setInvalidMonth, setSetInvalidMonth] = useState(false);

  const handleMonthBlur = () => {
    const isValid = /^(0?[1-9]|1[0-2])$/.test(props.selectedAttributes.find(attr => attr.type === 'birthdate')?.value || '');
    setSetInvalidMonth(false);
    if (!isValid) {
      console.error("Mês inválido! Digite um valor entre 1 e 12.");
      setSetInvalidMonth(true);
    }
  };

  return (
    <ListGroup>
      {props.selectedAttributes.map((attr) => {

        return (
          <ListGroupItem key={attr.id}>
            <div>
              <strong>{attr.name}</strong>
              {attr.type === 'boolean' && (
                <div className='d-flex gap-2 align-items-center'>
                  <Input
                    type="select"
                    value={attr.value}
                    onChange={(e) =>
                      props.handleInputChange(attr.id, 'value', e.target.value)
                    }
                  >
                    <option value="">Selecione</option>
                    <option value="true">Sim</option>
                    <option value="false">Não</option>
                  </Input>
                  {!attr.required ?
                    <FaTrash
                      style={{ cursor: "pointer" }}
                      onClick={() => props.RemoveDragableItem(attr.id)}
                    /> : null}
                </div>
              )}
              {(attr.type === 'number' || attr.type === 'date') && (
                <div className='d-flex gap-2 align-items-center'>
                  <>
                    <Input
                      type={attr.type === 'number' ? 'number' : 'date'}
                      placeholder="Digite o valor"
                      value={
                        (attr.type === 'date') && attr.value !== ""
                          ? new Date(attr.value).toISOString().split('T')[0]
                          : attr.value
                      }
                      onChange={(e) =>
                        props.handleInputChange(attr.id, 'value', e.target.value)
                      }
                    />
                    <div className="mt-2 d-flex gap-4">
                      <Label check className='d-flex gap-2'>
                        <Input
                          type="radio"
                          name={`condition-${attr.id}`}
                          value="greater"
                          checked={attr.condition === 'greater'}
                          onChange={(e) =>
                            props.handleInputChange(attr.id, 'condition', e.target.value)
                          }
                        />
                        Maior que
                      </Label>
                      <Label check className="d-flex gap-2">
                        <Input
                          type="radio"
                          name={`condition-${attr.id}`}
                          value="less"
                          checked={attr.condition === 'less'}
                          onChange={(e) =>
                            props.handleInputChange(attr.id, 'condition', e.target.value)
                          }
                        />
                        Menor que
                      </Label>
                    </div>
                  </>
                  {!attr.required ?
                    <FaTrash
                      style={{ cursor: "pointer" }}
                      onClick={() => props.RemoveDragableItem(attr.id)}
                    /> : null}
                </div>
              )}
              {(attr.type === 'range') && (
                <div className='d-flex flex-column gap-1 align-items-start'>
                  <div className="d-flex flex-column gap-2 ">
                    <DatePicker
                      className="d-flex rounded-4 p-1"
                      selected={attr.name === 'Data Cadastro' ? props.startDate : props.startDateConsulta}
                      locale="pt-BR"
                      dateFormat="dd/MM/yyyy"
                      onChange={(date: Date | null) => {

                        if (attr.name === 'Data Cadastro') {
                          props.setDateRange([date, props.endDate]);
                        } else {
                          props.setDateConsulta([date, props.endDateConsulta]);
                        }
                      }}
                      selectsStart
                      startDate={attr.name === 'Data Cadastro' ? props.startDate : props.startDateConsulta}
                      endDate={attr.name === 'Data Cadastro' ? props.endDate : props.endDateConsulta}
                      placeholderText="Data inícial"
                    />

                    <DatePicker
                      className="d-flex rounded-4 p-1"
                      selected={attr.name === 'Data Cadastro' ? props.endDate : props.endDateConsulta}
                      locale="pt-BR"
                      dateFormat="dd/MM/yyyy"
                      onChange={(date: Date | null) => {
                        if (attr.name === 'Data Cadastro') {
                          props.setDateRange([props.startDate, date]);
                        } else {
                          props.setDateConsulta([props.startDateConsulta, date]);
                        }
                      }}
                      selectsEnd
                      startDate={attr.name === 'Data Cadastro' ? props.startDate : props.startDateConsulta}
                      endDate={attr.name === 'Data Cadastro' ? props.endDate : props.endDateConsulta}
                      placeholderText="Data final"
                    />
                  </div>
                  {!attr.required ?
                    <FaTrash
                      style={{ cursor: "pointer" }}
                      onClick={() => props.RemoveDragableItem(attr.id)}
                    /> : null}
                </div>
              )}
              {attr.name === 'Fase' && (
                <Input
                  type='select'
                  value={attr.value}
                  readOnly
                  onChange={(e) =>
                    props.handleInputChange(attr.id, 'value', e.target.value)}
                >
                  <option value="">Selecione</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="3,4">3,4</option>
                </Input>

              )}
              {(attr.type === 'birthdate') && (
                <div className='d-flex gap-1 align-items-start'>
                  {/* date picker with only month */}
                  <Input
                    type="text"
                    value={attr.value}
                    onChange={(e) => props.handleInputChange(attr.id, 'value', e.target.value)}
                    onBlur={handleMonthBlur}
                    maxLength={2}
                  />
                  <FormFeedback
                    className={setInvalidMonth ? 'd-block' : 'd-none'}
                    style={{ color: 'red' }}
                  >
                    Mês inválido! Digite um valor entre 1 e 12.
                  </FormFeedback>
                  {!attr.required ?
                    <FaTrash
                      style={{ cursor: "pointer" }}
                      onClick={() => props.RemoveDragableItem(attr.id)}
                    /> : null}
                </div>
              )}
              {(attr.type === 'string') && (
                <AgenteInput
                  attr={attr}
                  handleInputChange={props.handleInputChange}
                  RemoveDragableItem={props.RemoveDragableItem}
                />
              )}
            </div>
          </ListGroupItem>
        )
      })}
    </ListGroup>
  )
}

type AgenteInputProps = {
  attr: any;
  handleInputChange: (id: string, field: string, value: any) => void;
  RemoveDragableItem: (id: string) => void;
};

const AgenteInput: React.FC<AgenteInputProps> = ({ attr, handleInputChange, RemoveDragableItem }) => {
  const [inputValue, setInputValue] = useState(attr.value || '');
  const [suggestions, setSuggestions] = useState<Tagente[]>([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  // Fetch do backend quando input mudar
  useEffect(() => {
    const abortController = new AbortController();
    if (inputValue.length < 2) {
      setSuggestions([]);
      return;
    }

    const fetchAgentes = async () => {
      try {
        const res = await Api.get(`/agentes/${inputValue.toUpperCase()}`);
        setSuggestions(res.data);
        setShowSuggestions(true);
      } catch (err) {
        console.error("Erro ao buscar agentes", err);
      }
    };

    const delay = setTimeout(fetchAgentes, 300); // debounce
    return () => {
      clearTimeout(delay);
      abortController.abort();
    }
  }, [inputValue]);

  const handleSelect = (nome: string) => {
    setInputValue(nome);
    setShowSuggestions(false);
    handleInputChange(attr.id, "value", nome);
  };

  return (
    <div className="position-relative">
      <Input
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onFocus={() => setShowSuggestions(true)}
        onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
      />

      {showSuggestions && suggestions.length > 0 && (
        <ul className="autocomplete-list">
          {suggestions.map((nome, idx) => (
            <li
              key={idx}
              onClick={() => handleSelect(nome.user)}
              className="autocomplete-item"
            >
              {nome.user}
            </li>
          ))}
        </ul>
      )}

      {!attr.required && (
        <FaTrash
          style={{ cursor: "pointer" }}
          onClick={() => RemoveDragableItem(attr.id)}
        />
      )}
    </div>
  );
};
